module.exports = __webpack_public_path__ + "05_mole.99f5c9bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer2/05_mole.png
// module id = ICBO
// module chunks = 0